<div class="spinner" *ngIf="enabledSpinner">
    <mat-spinner></mat-spinner>
</div>